import { createContext } from 'react';

export const HideCanvasAttachmentsContext = createContext(false);
